import debounce from '../util/debounce';

const selectors = {
  cartNote: '[data-cart-note]',
};

export class CartNotes {
  constructor(element) {
    this.inputs = element.querySelectorAll(selectors.cartNote);
    this.initInputs();
  }

  initInputs() {
    this.inputs.forEach((input) => {
      input.addEventListener(
        'input',
        debounce(
          function (e) {
            const note = e.target.value.toString() || '';
            this.saveNotes(note);
          }.bind(this),
          300
        )
      );
    });
  }

  saveNotes(newNote) {
    window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({note: newNote}),
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
